import React from 'react'
import Shimmer from 'Components/shimmer'
const ShimmerArticle = () => {
  return (
    <div className="list-shimmer">
      <div className="card-shimmer" >
        <Shimmer height="100px" width="100px" />
        <div className='shimmer-child-container'>
          <div className='tag'>
            <Shimmer height="14px" width="125px" />
          </div>
          <div className='title'>
            <Shimmer height="16px" width="100%" />
            <Shimmer height="16px" width="100%" />
          </div>
          <div className='author'>
            <Shimmer height="14px" width="50%" />
          </div>
        </div>
      </div>
      <style jsx global>
        {`
          .fdn-shimmer {
            margin: 0px !important;
          }
        `}
      </style>
      <style jsx>
        {`
          .card-shimmer {
            display: grid;
            gap: 8px;
            grid-template-columns: 100px auto;
            padding-bottom: 20px;
            border-bottom: 1px solid #dfe3e8;
            margin-bottom: 40px;
          }
          .list-shimmer {
            row-gap: 20px;
            display: grid;
          }
          .shimmer-child-container {
            display: flex;
            flex-direction: column;
          }
          .tag {
            margin-bottom: 4px;
          }
          .title {
            height: 48px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .author {
            margin-top: 14px;
          }
        `}
      </style>
    </div>
  )
}

export default ShimmerArticle
